import React, { useState, useEffect, useMemo } from 'react';

const STORAGE_KEY = 'ev-route-configs';
const API_URL = process.env.REACT_APP_API_URL || '';

const styles = {
  settingsPanel: {
    position: 'relative',
  },
  settingsGear: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#6c757d',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s, transform 0.2s',
  },
  settingsGearHover: {
    backgroundColor: '#5a6268',
    transform: 'rotate(45deg)',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    width: '100%',
    overflowY: 'auto',
  },
  modalTitle: {
    margin: '0 0 20px 0',
    fontSize: '1.5rem',
    color: '#333',
    borderBottom: '2px solid #007bff',
    paddingBottom: '10px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '24px',
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#555',
  },
  input: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    outline: 'none',
  },
  inputFocus: {
    borderColor: '#007bff',
    boxShadow: '0 0 0 3px rgba(0, 123, 255, 0.15)',
  },
  addConfigBtn: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    marginTop: '8px',
  },
  addConfigBtnHover: {
    backgroundColor: '#218838',
  },
  savedConfigsSection: {
    borderTop: '1px solid #eee',
    paddingTop: '20px',
    marginTop: '20px',
  },
  savedConfigsTitle: {
    margin: '0 0 12px 0',
    fontSize: '1.1rem',
    color: '#444',
  },
  configItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    marginBottom: '8px',
    gap: '10px',
  },
  configInfo: {
    flex: 1,
    minWidth: 0,
  },
  configName: {
    fontWeight: '600',
    color: '#333',
    marginBottom: '4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  configRoute: {
    fontSize: '12px',
    color: '#666',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  configActions: {
    display: 'flex',
    gap: '8px',
    flexShrink: 0,
  },
  loadBtn: {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  loadBtnHover: {
    backgroundColor: '#0056b3',
  },
  deleteBtn: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    width: '28px',
    height: '28px',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteBtnHover: {
    backgroundColor: '#c82333',
  },
  closeBtn: {
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    marginTop: '16px',
    width: '100%',
  },
  closeBtnHover: {
    backgroundColor: '#5a6268',
  },
  noConfigs: {
    textAlign: 'center',
    color: '#888',
    padding: '20px',
    fontStyle: 'italic',
  },
  currentRouteInfo: {
    backgroundColor: '#e7f3ff',
    padding: '12px',
    borderRadius: '6px',
    marginBottom: '16px',
    fontSize: '13px',
    color: '#0056b3',
  },
  // Admin styles
  adminIcon: {
    background: '#ffd700',
    border: 'none',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
    marginLeft: '8px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  adminIconHover: {
    transform: 'scale(1.1)',
    boxShadow: '0 2px 8px rgba(255, 215, 0, 0.6)',
  },
  adminPanel: {
    backgroundColor: '#fff8dc',
    border: '2px solid #ffd700',
    borderRadius: '8px',
    padding: '16px',
    marginTop: '16px',
    marginBottom: '16px',
  },
  adminPanelTitle: {
    margin: '0 0 12px 0',
    fontSize: '1.1rem',
    color: '#b8860b',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  userList: {
    maxHeight: '200px',
    overflowY: 'auto',
    marginBottom: '12px',
  },
  userItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 12px',
    backgroundColor: 'white',
    borderRadius: '6px',
    marginBottom: '8px',
    border: '1px solid #e0e0e0',
  },
  userInfo: {
    flex: 1,
  },
  userName: {
    fontWeight: '600',
    color: '#333',
  },
  userConfigCount: {
    fontSize: '12px',
    color: '#666',
  },
  userActions: {
    display: 'flex',
    gap: '6px',
  },
  viewBtn: {
    backgroundColor: '#17a2b8',
    color: 'white',
    border: 'none',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '11px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  viewBtnHover: {
    backgroundColor: '#138496',
  },
  deleteUserBtn: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '11px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  deleteUserBtnHover: {
    backgroundColor: '#c82333',
  },
  closeAdminBtn: {
    backgroundColor: '#b8860b',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  closeAdminBtnHover: {
    backgroundColor: '#8b6914',
  },
  userConfigsPanel: {
    backgroundColor: '#f0f8ff',
    border: '1px solid #b0c4de',
    borderRadius: '6px',
    padding: '12px',
    marginTop: '12px',
  },
  userConfigsTitle: {
    margin: '0 0 10px 0',
    fontSize: '0.95rem',
    color: '#4169e1',
  },
  backBtn: {
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer',
    marginBottom: '10px',
    transition: 'background-color 0.2s',
  },
  backBtnHover: {
    backgroundColor: '#5a6268',
  },
  usernameRow: {
    display: 'flex',
    alignItems: 'center',
  },
  // Chargers cache styles
  cacheSection: {
    backgroundColor: '#f0fff0',
    border: '1px solid #90ee90',
    borderRadius: '6px',
    padding: '12px',
    marginTop: '16px',
    marginBottom: '16px',
  },
  cacheSectionTitle: {
    margin: '0 0 10px 0',
    fontSize: '0.95rem',
    color: '#228b22',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  cacheStats: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '10px',
  },
  refreshBtn: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    justifyContent: 'center',
  },
  refreshBtnHover: {
    backgroundColor: '#218838',
  },
  refreshBtnDisabled: {
    backgroundColor: '#6c757d',
    cursor: 'not-allowed',
  },
  cacheMessage: {
    fontSize: '12px',
    marginTop: '8px',
    padding: '8px',
    borderRadius: '4px',
  },
  cacheMessageSuccess: {
    backgroundColor: '#d4edda',
    color: '#155724',
  },
  cacheMessageError: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
  },
};

function SettingsPanel({ currentRoute, onLoadConfig, currentUser, onUserChange, onClose }) {
  const [username, setUsername] = useState(currentUser?.username || '');
  const [password, setPassword] = useState('');
  const [configName, setConfigName] = useState('');
  const [configs, setConfigs] = useState([]);
  const [hoveredAddBtn, setHoveredAddBtn] = useState(false);
  const [hoveredCloseBtn, setHoveredCloseBtn] = useState(false);
  const [hoveredLoadBtn, setHoveredLoadBtn] = useState(null);
  const [hoveredDeleteBtn, setHoveredDeleteBtn] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  
  // Admin state
  const [isAdminMode, setIsAdminMode] = useState(currentUser?.isAdmin || false);
  const [showAdminPanel, setShowAdminPanel] = useState(currentUser?.isAdmin || false);
  const [hoveredAdminIcon, setHoveredAdminIcon] = useState(false);
  const [hoveredCloseAdminBtn, setHoveredCloseAdminBtn] = useState(false);
  const [hoveredViewBtn, setHoveredViewBtn] = useState(null);
  const [hoveredDeleteUserBtn, setHoveredDeleteUserBtn] = useState(null);
  const [viewingUser, setViewingUser] = useState(null);
  const [hoveredBackBtn, setHoveredBackBtn] = useState(false);
  const [showAdminPasswordModal, setShowAdminPasswordModal] = useState(false);
  const [adminPasswordInput, setAdminPasswordInput] = useState('');

  // Restore admin mode if user is already logged in as admin
  useEffect(() => {
    if (currentUser?.isAdmin) {
      setIsAdminMode(true);
      setShowAdminPanel(true);
      setUsername(currentUser.username || '');
    }
  }, [currentUser]);
  
  // Chargers cache state
  const [cacheStats, setCacheStats] = useState(null);
  const [refreshingCache, setRefreshingCache] = useState(false);
  const [cacheMessage, setCacheMessage] = useState(null);
  const [hoveredRefreshBtn, setHoveredRefreshBtn] = useState(false);

  // User auth state
  const [userAuthMessage, setUserAuthMessage] = useState(null);
  const [showRegisterOption, setShowRegisterOption] = useState(false);
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [deletePassword, setDeletePassword] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Change password state
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);

  // Check if username is admin (prioriza el flag del backend sobre el username)
  const isAdminUser = !!currentUser?.isAdmin || (currentUser == null && username.trim() === 'Bevema_1512');

  // Get unique users from configs
  const uniqueUsers = useMemo(() => {
    const userMap = new Map();
    configs.forEach(config => {
      const user = config.username || 'Sin usuario';
      if (!userMap.has(user)) {
        userMap.set(user, { username: user, configCount: 0, configs: [] });
      }
      userMap.get(user).configCount++;
      userMap.get(user).configs.push(config);
    });
    return Array.from(userMap.values());
  }, [configs]);
  // Load saved configs from localStorage on mount
  useEffect(() => {
    const savedConfigs = localStorage.getItem(STORAGE_KEY);
    if (savedConfigs) {
      try {
        setConfigs(JSON.parse(savedConfigs));
      } catch (e) {
        console.error('Error parsing saved configs:', e);
        setConfigs([]);
      }
    }
  }, []);

  // Save configs to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(configs));
  }, [configs]);

  // Load cache stats when admin panel is shown
  useEffect(() => {
    if (showAdminPanel && isAdminMode) {
      fetchCacheStats();
    }
  }, [showAdminPanel, isAdminMode]);

  // Fetch chargers cache statistics (endpoint protegido: requiere admin)
  const fetchCacheStats = async () => {
    try {
      const params = new URLSearchParams({
        adminKey: currentUser?.username || username.trim(),
        adminPassword: password || '',
      });
      const response = await fetch(`${API_URL}/api/chargers/cache-stats?${params.toString()}`);
      if (response.status === 500 || !response.ok) {
        // El backend lanza "Unauthorized" como RuntimeException -> 500
        setCacheMessage({ type: 'error', text: 'No autorizado para ver estadísticas de caché' });
        return;
      }
      const data = await response.json();
      if (data.success) {
        setCacheStats(data);
      }
    } catch (error) {
      console.error('Error fetching cache stats:', error);
    }
  };

  // Refresh chargers cache (admin only)
  const refreshChargersCache = async () => {
    setRefreshingCache(true);
    setCacheMessage(null);

    try {
      if (!window.confirm('¿Confirmas refrescar la caché de cargadores? Esto creará una copia de seguridad del fichero actual y lo sobrescribirá.')) {
        setRefreshingCache(false);
        return;
      }

      const response = await fetch(`${API_URL}/api/chargers/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ adminKey: currentUser?.username || username.trim(), adminPassword: password, confirm: true }),
      });

      const data = await response.json();

      if (data.success) {
        setCacheMessage({
          type: 'success',
          text: `Caché actualizada: ${data.count} cargadores cargados`,
        });
        // Refresh stats
        await fetchCacheStats();
      } else {
        setCacheMessage({
          type: 'error',
          text: data.error?.message || 'Error al refrescar caché',
        });
      }
    } catch (error) {
      setCacheMessage({
        type: 'error',
        text: `Error: ${error.message}`,
      });
    } finally {
      setRefreshingCache(false);
    }
  };

  const closeModal = () => {
    setPassword(''); // Clear password on close for security
    setIsAdminMode(false);
    setShowAdminPanel(false);
    setViewingUser(null);
    if (onClose) onClose();
  };

  // Admin click handler
  const handleAdminClick = async () => {
    setShowAdminPasswordModal(true);
    setAdminPasswordInput('');
  };

  const handleAdminPasswordSubmit = async () => {
    const enteredPassword = adminPasswordInput;
    if (!enteredPassword) {
      alert('Introduce la contraseña de administrador');
      return;
    }
    try {
      // 1) Obtenemos el username admin del backend (evita hardcodearlo en el cliente)
      const infoRes = await fetch(`${API_URL}/api/users/admin-info`);
      const infoData = await infoRes.json();
      const adminUsername = infoData?.data?.username;
      if (!adminUsername) {
        alert('No se pudo obtener el usuario administrador del servidor');
        return;
      }
      // 2) Login contra el backend — el backend valida BCrypt y el flag isAdmin
      const res = await fetch(`${API_URL}/api/users/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: adminUsername, password: enteredPassword })
      });
      const data = await res.json();
      if (data.success && data.data?.isAdmin === true) {
        setShowAdminPasswordModal(false);
        setPassword(enteredPassword);
        setIsAdminMode(true);
        setShowAdminPanel(true);
        setUsername(adminUsername);
        onUserChange({
          id: data.data.id,
          username: data.data.username,
          isAdmin: true,
        });
      } else {
        alert('Contraseña incorrecta o usuario sin permisos de administrador');
      }
    } catch (e) {
      alert('Error de conexión con el servidor: ' + (e?.message || e));
    }
  };

  // Delete all configs for a user
  const deleteUserConfigs = (targetUsername) => {
    if (window.confirm(`¿Eliminar todas las configuraciones de ${targetUsername}?`)) {
      setConfigs(prevConfigs => prevConfigs.filter(c => (c.username || 'Sin usuario') !== targetUsername));
      if (viewingUser && viewingUser.username === targetUsername) {
        setViewingUser(null);
      }
    }
  };

  // View a user's configurations
  const viewUserConfigs = (user) => {
    setViewingUser(user);
  };

  const saveConfig = () => {
    if (!configName.trim()) {
      alert('Por favor, introduce un nombre para la configuración');
      return;
    }

    if (!currentRoute) {
      alert('No hay datos de ruta para guardar');
      return;
    }

    const newConfig = {
      id: Date.now().toString(),
      name: configName.trim(),
      username: username.trim(),
      createdAt: new Date().toISOString(),
      origin: currentRoute.origin || '',
      destination: currentRoute.destination || '',
      distance: currentRoute.distance || 0,
      kmPoints: currentRoute.kmPoints || [],
      maxDeviation: currentRoute.maxDeviation || 0,
    };

    setConfigs(prevConfigs => [...prevConfigs, newConfig]);
    setConfigName('');
    alert('Configuración guardada correctamente');
  };

  const loadConfig = (config) => {
    if (onLoadConfig) {
      onLoadConfig({
        origin: config.origin,
        destination: config.destination,
        distance: config.distance,
        kmPoints: config.kmPoints,
        maxDeviation: config.maxDeviation,
      });
    }
    closeModal();
  };

  const deleteConfig = (configId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta configuración?')) {
      setConfigs(prevConfigs => prevConfigs.filter(c => c.id !== configId));
    }
  };

  const getInputStyle = (inputName) => ({
    ...styles.input,
    ...(focusedInput === inputName ? styles.inputFocus : {}),
  });

  return (
    <div style={styles.settingsPanel}>
      {/* Admin password modal */}
      {showAdminPasswordModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setShowAdminPasswordModal(false)}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '24px 28px', minWidth: 280, boxShadow: '0 8px 32px rgba(0,0,0,0.25)' }} onClick={e => e.stopPropagation()}>
            <h4 style={{ margin: '0 0 16px', fontSize: '1.1em', color: '#1e293b' }}>🔐 Contraseña de administrador</h4>
            <div>
              <input
                type="password"
                value={adminPasswordInput}
                onChange={e => setAdminPasswordInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') handleAdminPasswordSubmit(); }}
                placeholder="Introduce la contraseña"
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: '0.95em', boxSizing: 'border-box' }}
                autoFocus
              />
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowAdminPasswordModal(false)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #d1d5db', background: '#f3f4f6', cursor: 'pointer', fontSize: '0.9em' }}>Cancelar</button>
              <button onClick={handleAdminPasswordSubmit} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', cursor: 'pointer', fontSize: '0.9em', fontWeight: 600 }}>Acceder</button>
            </div>
          </div>
        </div>
      )}
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h3 style={styles.modalTitle}>Configuraciones</h3>

            {currentRoute && (
              <div style={styles.currentRouteInfo}>
                <strong>Ruta actual:</strong> {currentRoute.origin || '(sin origen)'} → {currentRoute.destination || '(sin destino)'}
                {currentRoute.distance > 0 && ` (${currentRoute.distance} km)`}
              </div>
            )}

            <div style={styles.form}>
              <label style={styles.label}>
                Usuario
                <div style={styles.usernameRow}>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => { setUsername(e.target.value); setShowRegisterOption(false); setUserAuthMessage(null); }}
                    style={{ ...getInputStyle('username'), flex: 1 }}
                    onFocus={() => setFocusedInput('username')}
                    onBlur={() => setFocusedInput(null)}
                    placeholder="Tu nombre de usuario"
                  />
                  {isAdminUser && (
                    <button
                      onClick={handleAdminClick}
                      style={{
                        ...styles.adminIcon,
                        ...(hoveredAdminIcon ? styles.adminIconHover : {}),
                      }}
                      onMouseEnter={() => setHoveredAdminIcon(true)}
                      onMouseLeave={() => setHoveredAdminIcon(false)}
                      title="Administrador"
                      type="button"
                    >
                      👑
                    </button>
                  )}
                </div>
              </label>

              <label style={styles.label}>
                Contraseña
                <input
                  type="password"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setShowRegisterOption(false); setUserAuthMessage(null); }}
                  style={getInputStyle('password')}
                  onFocus={() => setFocusedInput('password')}
                  onBlur={() => setFocusedInput(null)}
                  placeholder="********"
                />
              </label>

              {/* User login/register buttons */}
              {!currentUser && (
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <button
                    type="button"
                    style={{ ...styles.addConfigBtn, marginTop: 0, flex: 1, backgroundColor: '#2563eb' }}
                    onClick={async () => {
                      if (!username.trim() || !password.trim()) { setUserAuthMessage({ type: 'error', text: 'Usuario y contraseña requeridos' }); return; }
                      try {
                        const res = await fetch(`${API_URL}/api/users/login`, {
                          method: 'POST', headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ username: username.trim(), password: password.trim() })
                        });
                        const data = await res.json();
                        if (data.success) {
                          // isAdmin viene del backend (no se calcula en cliente)
                          onUserChange({ id: data.data.id, username: data.data.username, isAdmin: !!data.data.isAdmin, powerRangeConfig: data.data.powerRangeConfig || null });
                          setUserAuthMessage({ type: 'success', text: '✅ Sesión iniciada' });
                          setShowRegisterOption(false);
                        } else if (data.data?.userNotFound) {
                          setShowRegisterOption(true);
                          setUserAuthMessage({ type: 'info', text: '⚠️ Usuario no encontrado. ¿Deseas registrarte?' });
                        } else {
                          setUserAuthMessage({ type: 'error', text: '❌ ' + (data.message || 'Contraseña incorrecta') });
                        }
                      } catch (err) { setUserAuthMessage({ type: 'error', text: '❌ Error de conexión' }); }
                    }}
                  >
                    🔑 Identificarse
                  </button>
                  {showRegisterOption && (
                    <button
                      type="button"
                      style={{ ...styles.addConfigBtn, marginTop: 0, flex: 1, backgroundColor: '#059669' }}
                      onClick={async () => {
                        try {
                          const res = await fetch(`${API_URL}/api/users/register`, {
                            method: 'POST', headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ username: username.trim(), password: password.trim() })
                          });
                          const data = await res.json();
                          if (data.success) {
                            onUserChange({ id: data.data.id, username: data.data.username, isAdmin: !!data.data.isAdmin, powerRangeConfig: data.data.powerRangeConfig || null });
                            setUserAuthMessage({ type: 'success', text: '✅ Usuario registrado e identificado' });
                            setShowRegisterOption(false);
                          } else {
                            setUserAuthMessage({ type: 'error', text: '❌ ' + (data.message || 'Error al registrar') });
                          }
                        } catch (err) { setUserAuthMessage({ type: 'error', text: '❌ Error de conexión' }); }
                      }}
                    >
                      📝 Registrarse
                    </button>
                  )}
                </div>
              )}
              {currentUser && (
                <>
                <div style={{ padding: '8px 12px', background: '#dbeafe', borderRadius: '6px', fontSize: '0.9em', color: '#1d4ed8', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>✅ Identificado como <strong>{currentUser.username}</strong>{currentUser.isAdmin ? ' 👑' : ''}</span>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button
                      type="button"
                      onClick={() => { onUserChange(null); setUsername(''); setPassword(''); setIsAdminMode(false); setShowAdminPanel(false); setShowDeleteAccount(false); }}
                      style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: '4px', padding: '3px 10px', cursor: 'pointer', fontSize: '0.85em' }}
                    >
                      Cerrar sesión
                    </button>
                  </div>
                </div>
                {/* Delete account option */}
                {!showDeleteAccount && !showChangePassword && (
                  <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                    <button
                      type="button"
                      onClick={() => setShowChangePassword(true)}
                      style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontSize: '0.8em', padding: '4px 0', textDecoration: 'underline' }}
                    >
                      🔑 Cambiar contraseña
                    </button>
                    <button
                      type="button"
                      onClick={() => setShowDeleteAccount(true)}
                      style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: '0.8em', padding: '4px 0', textDecoration: 'underline' }}
                    >
                      🗑️ Eliminar mi cuenta
                    </button>
                  </div>
                )}
                {/* Change password form */}
                {showChangePassword && (
                  <div style={{ padding: '10px', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '6px', fontSize: '0.85em' }}>
                    <p style={{ margin: '0 0 8px', color: '#1e40af', fontWeight: 600 }}>
                      🔑 Cambiar contraseña
                    </p>
                    <input
                      type="password"
                      value={oldPassword}
                      onChange={e => setOldPassword(e.target.value)}
                      placeholder="Contraseña actual"
                      autoComplete="current-password"
                      style={{ width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #93c5fd', marginBottom: '6px', fontSize: '0.9em' }}
                    />
                    <input
                      type="password"
                      value={newPassword}
                      onChange={e => setNewPassword(e.target.value)}
                      placeholder="Nueva contraseña (mín. 4 caracteres)"
                      autoComplete="new-password"
                      style={{ width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #93c5fd', marginBottom: '6px', fontSize: '0.9em' }}
                    />
                    <input
                      type="password"
                      value={newPasswordConfirm}
                      onChange={e => setNewPasswordConfirm(e.target.value)}
                      placeholder="Repite la nueva contraseña"
                      autoComplete="new-password"
                      style={{ width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #93c5fd', marginBottom: '8px', fontSize: '0.9em' }}
                    />
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        type="button"
                        disabled={changePasswordLoading || !oldPassword || !newPassword || newPassword !== newPasswordConfirm}
                        onClick={async () => {
                          setChangePasswordLoading(true);
                          try {
                            const res = await fetch(`${API_URL}/api/users/change-password`, {
                              method: 'POST', headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                userId: String(currentUser.id),
                                oldPassword: oldPassword,
                                newPassword: newPassword,
                              }),
                            });
                            const data = await res.json();
                            if (data.success) {
                              setUserAuthMessage({ type: 'success', text: '✅ Contraseña cambiada. Vuelve a iniciar sesión con la nueva.' });
                              // Limpiar estado de passwords y forzar re-login
                              setOldPassword(''); setNewPassword(''); setNewPasswordConfirm('');
                              setShowChangePassword(false);
                              onUserChange(null);
                              setUsername(''); setPassword('');
                            } else {
                              setUserAuthMessage({ type: 'error', text: '❌ ' + (data.message || 'Error al cambiar contraseña') });
                            }
                          } catch (err) { setUserAuthMessage({ type: 'error', text: '❌ Error de conexión' }); }
                          setChangePasswordLoading(false);
                        }}
                        style={{ flex: 1, background: '#2563eb', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px', cursor: 'pointer', fontSize: '0.85em', opacity: (changePasswordLoading || !oldPassword || !newPassword || newPassword !== newPasswordConfirm) ? 0.5 : 1 }}
                      >
                        {changePasswordLoading ? 'Cambiando...' : '🔑 Cambiar'}
                      </button>
                      <button
                        type="button"
                        onClick={() => { setShowChangePassword(false); setOldPassword(''); setNewPassword(''); setNewPasswordConfirm(''); }}
                        style={{ flex: 1, background: '#6b7280', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px', cursor: 'pointer', fontSize: '0.85em' }}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}
                {/* Delete account form */}
                {showDeleteAccount && (
                  <div style={{ padding: '10px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px', fontSize: '0.85em' }}>
                    <p style={{ margin: '0 0 8px', color: '#991b1b', fontWeight: 600 }}>
                      ⚠️ ¿Estás seguro de que deseas eliminar tu cuenta?
                    </p>
                    <p style={{ margin: '0 0 8px', color: '#7f1d1d', fontSize: '0.9em' }}>
                      Se eliminará completamente tu usuario y todas las rutas guardadas. Esta acción no se puede deshacer.
                    </p>
                    <input
                      type="password"
                      value={deletePassword}
                      onChange={e => setDeletePassword(e.target.value)}
                      placeholder="Confirma tu contraseña"
                      style={{ width: '100%', padding: '6px 8px', borderRadius: '4px', border: '1px solid #fca5a5', marginBottom: '8px', fontSize: '0.9em' }}
                    />
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        type="button"
                        disabled={deleteLoading || !deletePassword.trim()}
                        onClick={async () => {
                          setDeleteLoading(true);
                          try {
                            const res = await fetch(`${API_URL}/api/users/${currentUser.id}`, {
                              method: 'DELETE', headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ password: deletePassword.trim() })
                            });
                            const data = await res.json();
                            if (data.success) {
                              // Remove user configs from localStorage
                              const allConfigs = JSON.parse(localStorage.getItem('evplanner-route-configs') || '[]');
                              const filtered = allConfigs.filter(c => c.username !== currentUser.username);
                              localStorage.setItem('evplanner-route-configs', JSON.stringify(filtered));
                              onUserChange(null);
                              setUsername(''); setPassword(''); setDeletePassword('');
                              setShowDeleteAccount(false); setIsAdminMode(false); setShowAdminPanel(false);
                              setUserAuthMessage({ type: 'success', text: '✅ Cuenta eliminada correctamente' });
                            } else {
                              setUserAuthMessage({ type: 'error', text: '❌ ' + (data.message || 'Error al eliminar') });
                            }
                          } catch (err) { setUserAuthMessage({ type: 'error', text: '❌ Error de conexión' }); }
                          setDeleteLoading(false);
                        }}
                        style={{ flex: 1, background: '#dc2626', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px', cursor: 'pointer', fontSize: '0.85em', opacity: deleteLoading || !deletePassword.trim() ? 0.5 : 1 }}
                      >
                        {deleteLoading ? 'Eliminando...' : '🗑️ Confirmar eliminación'}
                      </button>
                      <button
                        type="button"
                        onClick={() => { setShowDeleteAccount(false); setDeletePassword(''); }}
                        style={{ flex: 1, background: '#6b7280', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px', cursor: 'pointer', fontSize: '0.85em' }}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}
                </>
              )}
              {userAuthMessage && (
                <div style={{
                  padding: '6px 10px', borderRadius: '4px', fontSize: '0.85em',
                  backgroundColor: userAuthMessage.type === 'success' ? '#d1fae5' : userAuthMessage.type === 'info' ? '#fef3c7' : '#fee2e2',
                  color: userAuthMessage.type === 'success' ? '#065f46' : userAuthMessage.type === 'info' ? '#92400e' : '#991b1b',
                }}>
                  {userAuthMessage.text}
                </div>
              )}

              <label style={styles.label}>
                Nombre de la configuración
                <input
                  type="text"
                  value={configName}
                  onChange={(e) => setConfigName(e.target.value)}
                  style={getInputStyle('configName')}
                  onFocus={() => setFocusedInput('configName')}
                  onBlur={() => setFocusedInput(null)}
                  placeholder="Ej: Ruta Madrid-Barcelona"
                />
              </label>

              <button
                style={{
                  ...styles.addConfigBtn,
                  ...(hoveredAddBtn ? styles.addConfigBtnHover : {}),
                }}
                onClick={saveConfig}
                onMouseEnter={() => setHoveredAddBtn(true)}
                onMouseLeave={() => setHoveredAddBtn(false)}
              >
                + Guardar configuración
              </button>
            </div>

            {/* Admin Panel */}
            {showAdminPanel && isAdminMode && (
              <div style={styles.adminPanel}>
                <h4 style={styles.adminPanelTitle}>
                  👑 Panel de Administración
                </h4>
                
                {!viewingUser ? (
                  <>
                    <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#666' }}>
                      Usuarios registrados: {uniqueUsers.length}
                    </p>
                    <div style={styles.userList}>
                      {uniqueUsers.length === 0 ? (
                        <div style={{ textAlign: 'center', color: '#888', padding: '16px', fontStyle: 'italic' }}>
                          No hay usuarios con configuraciones
                        </div>
                      ) : (
                        uniqueUsers.map(user => (
                          <div key={user.username} style={styles.userItem}>
                            <div style={styles.userInfo}>
                              <span style={styles.userName}>{user.username}</span>
                              <span style={styles.userConfigCount}> - {user.configCount} configuración{user.configCount !== 1 ? 'es' : ''}</span>
                            </div>
                            <div style={styles.userActions}>
                              <button
                                style={{
                                  ...styles.viewBtn,
                                  ...(hoveredViewBtn === user.username ? styles.viewBtnHover : {}),
                                }}
                                onClick={() => viewUserConfigs(user)}
                                onMouseEnter={() => setHoveredViewBtn(user.username)}
                                onMouseLeave={() => setHoveredViewBtn(null)}
                              >
                                Ver
                              </button>
                              <button
                                style={{
                                  ...styles.deleteUserBtn,
                                  ...(hoveredDeleteUserBtn === user.username ? styles.deleteUserBtnHover : {}),
                                }}
                                onClick={() => deleteUserConfigs(user.username)}
                                onMouseEnter={() => setHoveredDeleteUserBtn(user.username)}
                                onMouseLeave={() => setHoveredDeleteUserBtn(null)}
                              >
                                Eliminar
                              </button>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </>
                ) : (
                  <div style={styles.userConfigsPanel}>
                    <button
                      style={{
                        ...styles.backBtn,
                        ...(hoveredBackBtn ? styles.backBtnHover : {}),
                      }}
                      onClick={() => setViewingUser(null)}
                      onMouseEnter={() => setHoveredBackBtn(true)}
                      onMouseLeave={() => setHoveredBackBtn(false)}
                    >
                      ← Volver
                    </button>
                    <h5 style={styles.userConfigsTitle}>
                      Configuraciones de {viewingUser.username}
                    </h5>
                    {viewingUser.configs.map(config => (
                      <div key={config.id} style={styles.configItem}>
                        <div style={styles.configInfo}>
                          <div style={styles.configName}>{config.name}</div>
                          <div style={styles.configRoute}>
                            {config.origin || '?'} → {config.destination || '?'}
                            {config.distance > 0 && ` (${config.distance} km)`}
                          </div>
                        </div>
                        <div style={styles.configActions}>
                          <button
                            style={{
                              ...styles.deleteBtn,
                              ...(hoveredDeleteBtn === config.id ? styles.deleteBtnHover : {}),
                            }}
                            onClick={() => {
                              deleteConfig(config.id);
                              // Update viewingUser
                              const updatedConfigs = viewingUser.configs.filter(c => c.id !== config.id);
                              if (updatedConfigs.length === 0) {
                                setViewingUser(null);
                              } else {
                                setViewingUser({ ...viewingUser, configs: updatedConfigs, configCount: updatedConfigs.length });
                              }
                            }}
                            onMouseEnter={() => setHoveredDeleteBtn(config.id)}
                            onMouseLeave={() => setHoveredDeleteBtn(null)}
                            title="Eliminar configuración"
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                
                {/* Chargers Cache Section */}
                <div style={styles.cacheSection}>
                  <h5 style={styles.cacheSectionTitle}>
                    🔌 Caché de Cargadores
                  </h5>
                  
                  {cacheStats && (
                    <div style={styles.cacheStats}>
                      <p style={{ margin: '0 0 4px 0' }}>
                        <strong>Estado:</strong> {cacheStats.data?.hasCachedData ? '✅ Cargada en memoria' : '❌ Sin datos'}
                      </p>
                      {cacheStats.data?.hasCachedData && (
                        <>
                          <p style={{ margin: '0 0 4px 0' }}>
                            <strong>Cargadores en memoria:</strong> {(cacheStats.data?.count || 0).toLocaleString()}
                          </p>
                          <p style={{ margin: '0 0 4px 0' }}>
                            <strong>Última actualización:</strong>{' '}
                            {cacheStats.data?.lastUpdate 
                              ? new Date(cacheStats.data.lastUpdate).toLocaleString('es-ES')
                              : 'Nunca'}
                          </p>
                        </>
                      )}
                      <p style={{ margin: '0 0 4px 0' }}>
                        <strong>Fuente:</strong>{' '}
                        {cacheStats.data?.source || 'memory-cache'}
                      </p>
                    </div>
                  )}
                  
                  <button
                    style={{
                      ...styles.refreshBtn,
                      ...(hoveredRefreshBtn && !refreshingCache ? styles.refreshBtnHover : {}),
                      ...(refreshingCache ? styles.refreshBtnDisabled : {}),
                    }}
                    onClick={refreshChargersCache}
                    onMouseEnter={() => setHoveredRefreshBtn(true)}
                    onMouseLeave={() => setHoveredRefreshBtn(false)}
                    disabled={refreshingCache}
                  >
                    {refreshingCache ? (
                      <>⏳ Cargando cargadores de España...</>
                    ) : (
                      <>🔄 Refrescar caché de cargadores</>
                    )}
                  </button>
                  
                  {cacheMessage && (
                    <div style={{
                      ...styles.cacheMessage,
                      ...(cacheMessage.type === 'success' ? styles.cacheMessageSuccess : styles.cacheMessageError),
                    }}>
                      {cacheMessage.text}
                    </div>
                  )}
                </div>
                
                <button
                  style={{
                    ...styles.closeAdminBtn,
                    ...(hoveredCloseAdminBtn ? styles.closeAdminBtnHover : {}),
                  }}
                  onClick={() => {
                    setShowAdminPanel(false);
                    setViewingUser(null);
                  }}
                  onMouseEnter={() => setHoveredCloseAdminBtn(true)}
                  onMouseLeave={() => setHoveredCloseAdminBtn(false)}
                >
                  Cerrar Admin
                </button>
              </div>
            )}

            <div style={styles.savedConfigsSection}>
              <h4 style={styles.savedConfigsTitle}>Configuraciones guardadas</h4>
              
              {configs.length === 0 ? (
                <div style={styles.noConfigs}>
                  No hay configuraciones guardadas
                </div>
              ) : (
                configs.map((config) => (
                  <div style={styles.configItem} key={config.id}>
                    <div style={styles.configInfo}>
                      <div style={styles.configName}>{config.name}</div>
                      <div style={styles.configRoute}>
                        {config.origin || '?'} → {config.destination || '?'}
                        {config.distance > 0 && ` (${config.distance} km)`}
                      </div>
                    </div>
                    <div style={styles.configActions}>
                      <button
                        style={{
                          ...styles.loadBtn,
                          ...(hoveredLoadBtn === config.id ? styles.loadBtnHover : {}),
                        }}
                        onClick={() => loadConfig(config)}
                        onMouseEnter={() => setHoveredLoadBtn(config.id)}
                        onMouseLeave={() => setHoveredLoadBtn(null)}
                      >
                        Cargar
                      </button>
                      <button
                        style={{
                          ...styles.deleteBtn,
                          ...(hoveredDeleteBtn === config.id ? styles.deleteBtnHover : {}),
                        }}
                        onClick={() => deleteConfig(config.id)}
                        onMouseEnter={() => setHoveredDeleteBtn(config.id)}
                        onMouseLeave={() => setHoveredDeleteBtn(null)}
                        title="Eliminar"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>

            <button
              style={{
                ...styles.closeBtn,
                ...(hoveredCloseBtn ? styles.closeBtnHover : {}),
              }}
              onClick={closeModal}
              onMouseEnter={() => setHoveredCloseBtn(true)}
              onMouseLeave={() => setHoveredCloseBtn(false)}
            >
              Cerrar
            </button>
          </div>
    </div>
  );
}

export default SettingsPanel;
